import { View, Button } from "@/components/ui";
import { useRoute } from "@/components/shared/router";
import { PromoImageChatSales } from "@/components/shared/promo-card";
import { ListHeading } from "@/components/shared/list-header";
import { IfElse } from "@/components/shared/if-else";
import { EmptyCard } from "@/components/shared/empty-card";
import NoPromos from "@/assets/images/3d-illus/no-promos.png";

const promoData = [
  {
    link: "https://luce-production.sgp1.cdn.digitaloceanspaces.com/public/1-promo-aircon-2024.png",
    message:
      "Hi! I'd like to speak to sales about booking a new aircon service appointment and use the $15 off promotion through your web application. Could you please assist me with the details?",
  },
  {
    link: "https://luce-production.sgp1.cdn.digitaloceanspaces.com/public/2-promo-home-beauty-2024.png",
    message:
      "Hi! I'd like to speak to sales about booking a new home beauty appointment and use the $15 off promotion through your web application. Could you please assist me with the details?",
  },
];

export function Promos({ toggleHeader = true }: { toggleHeader?: boolean }) {
  const { push } = useRoute();
  return (
    <View className="flex max-w-screen-lg flex-col gap-2">
      {toggleHeader && (
        <ListHeading
          title="Promos"
          action={
            !!promoData.length && (
              <Button
                variant="secondary"
                size="xs"
                color="CTA2"
                onClick={() => {
                  push({ pageKey: "promos" });
                }}
                children="View All"
              />
            )
          }
        />
      )}

      <View className="promo-list-contents flex flex-col gap-4">
        <IfElse
          if={!!promoData.length}
          else={
            <EmptyCard
              src={NoPromos}
              title="No Promos Available"
              desc="Come back later for more exciting promos!"
            />
          }
        >
          {promoData.map((promo) => (
            <PromoImageChatSales
              key={promo.link}
              imageUrl={promo.link}
              message={promo.message}
            />
          ))}
        </IfElse>
      </View>
    </View>
  );
}
